import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Checkbox, Divider, Modal, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";
import { ModalClose, Sheet } from "@mui/joy";
import toast from "react-hot-toast";

export default function WelcomeScreen() {

  const accessToken = useMemo(() => localStorage.getItem('NCProAccessToken'), []);
  const [announcements, setAnnouncements] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  const { userData } = useSelector((state) => state.user);

  const getAnnouncement = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/announcement/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setAnnouncements(response.data);
      if (announcements) {
        setOpen(true);
      }
    } catch (error) {
      console.log(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handleOk = async () => {
    if (checked) {
      try {
        const payload = {
          userId: userData.userAutoGeneratedId,
          is_active: false
        };
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/announcement/update/${announcements.data[0].notification_id}`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }
          }
        );

        if (response) {
          setOpen(false);
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    }
    else {
      setOpen(false);
    }
  }

  useEffect(() => {
    getAnnouncement(userData.userAutoGeneratedId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, accessToken]);

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url('/images/bannerBg.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          position: "absolute",
          pl: 30,
          top: 0,
          left: 0,
          zIndex: -999
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Typography
            variant="h1"
            sx={{
              fontFamily: 'Lato, sans-serif',
              fontSize: "34px",
              fontWeight: 400,
              lineHeight: "40.8px",
              textAlign: "center",
              textUnderlinePosition: "from-font",
              textDecorationSkipInk: "none",
            }}
          >
            Welcome to&nbsp;
            <span
              style={{
                background: "linear-gradient(270.29deg, #43B0D7 73.9%, #0D2663 99.75%)",
                color: "transparent",
                backgroundClip: "text",
                ml: 3,
              }}
            >
              NC Pro
            </span>
          </Typography>
          <Typography sx={{
            color: "#545454",
            textAlign: 'end',
            fontSize: '14px'
          }}>
            Version 2.1
          </Typography>
          {!loading && announcements && userData.roleCode !== 'SUPADM' &&
            < Modal
              aria-labelledby="modal-title"
              aria-describedby="modal-desc"
              open={open}
              onClose={() => setOpen(false)}
              sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <Sheet
                variant="outlined"
                sx={{ width: 800, borderRadius: 'md', boxShadow: 'lg', outline: 'none' }}
              >
                <ModalClose size='lg' variant="plain" onClick={() => setOpen(false)} />
                <Typography component="h2" sx={{
                  fontFamily: 'Lato, sans-serif',
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#000000',
                  px: 3,
                  py: 0.8,
                  mt: 1
                }}>
                  Announcement
                </Typography>
                <Divider sx={{ mb: 2, mt: 1 }} />
                <Typography component="h2" sx={{
                  fontFamily: 'Lato, sans-serif',
                  fontSize: '16px',
                  color: '#000000',
                  px: 3,
                  py: 0.8,
                  mt: 1,
                  wordBreak: 'break-word'
                }}>
                  {announcements?.data?.[0]?.message}
                </Typography>
                <Box sx={{
                  borderRadius: '0px 0px 10px 10px',
                  boxShadow: '0px -1px 4px 0px #00000026',
                  textAlign: 'right',
                  px: 3,
                  py: 1.5,
                  mt: 3,
                  display: 'flex',
                  justifyContent: 'space-between'
                }}>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    ml: -1.5
                  }}>
                    <Checkbox
                      size="small"
                      checked={checked}
                      onChange={() => setChecked(prev => !prev)}
                    />
                    <Typography component="h2" sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '16px',
                      color: '#000000',
                      cursor: "pointer",
                    }}
                      onClick={() => setChecked(prev => !prev)}>
                      Don't show me again
                    </Typography>
                  </Box>
                  <Button
                    onClick={handleOk}
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                      color: 'white',
                      textTransform: 'none',
                      borderRadius: '7px',
                      px: 2,
                    }}
                  >
                    Ok
                  </Button>
                </Box>
              </Sheet>
            </Modal>
          }
        </div>
      </Box>
    </div>
  );
}
